import { useState } from 'react'
import React from 'react'
import AgentApiService from '../services/AgentsApi';
import Markdown from 'react-markdown'
import { Spinner } from 'react-bootstrap';

//const functionUrl = 'http://localhost:8081/api/ai/test';

// type Message = {
//   text: string,
//   sender: 'ai' | 'user'
// };

function EPCBot() {
  const [ newInputValue, setNewInputValue ] = useState('');
  const [ messages, setMessages ] = useState([{sender:'ai', text: 'How can I assist you today? If you have questions about your property effeciency or energy performance certificate, just provide you postcode and property name or number to get started'}]);
  const [waiting, setWaiting] = useState(false);

  const newMessage = async (e) => {
    e.preventDefault();
    setNewInputValue('');
    const newMessages = [...messages, {
      text: newInputValue,
      sender: 'user'
    }];
    setMessages(newMessages);
    setWaiting(true);
    const response = await AgentApiService.aiTest({ messages: newMessages });
    setWaiting(false);
    // await fetch(functionUrl, {
    //   method: 'POST',
    //   body: JSON.stringify({ messages: newMessages })
    // });
    console.log(response.data);
    setMessages([...newMessages, {
      sender: 'ai',
      text: await response.data
    }]);
  }

  return <div className="container">
          <center>
  <main>
    <h1>EPC and Grant AI Agent</h1>
    <div>
    {messages.map((message, index) => <div className={"message " + message.sender}>
      <Markdown >
    {message.text}
    </Markdown>
    
    </div>
    
      )}
      {(waiting) &&  <Spinner animation="border" role="status"/>}
    </div>
    <form className="input-form" onSubmit={newMessage}>
      <input type="text"
            placeholder="Message"
            value={newInputValue} 
            
            onChange={e => setNewInputValue(e.currentTarget.value)} />
      <input disabled={waiting} type="submit" value="Send" />
    </form>
  </main>
  </center>
  </div>
}

export default EPCBot